<!-- 巡检管理 -->
<template>
    <div class="index-main">
        <a-row style="height: 100%;positive: relative">
            <a-col :span="6" class="cell-left">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 30%">
                        <InspectionAndMaintenance ref="InspectionAndMaintenanceRef"></InspectionAndMaintenance>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                        <!-- <InspectionTaskMonth ref="InspectionTaskMonthRef"></InspectionTaskMonth> -->
                        <!-- <InspectionDynamics ref="InspectionDynamicsRef"></InspectionDynamics> -->
                        <InspectionRegionalRanking ref="InspectionRegionalRankingRef" :titleImage="titleImage"/>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                        <MaintenancePeriod ref="MaintenancePeriodRef"></MaintenancePeriod>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="12" style="height: 100%;">
                <a-row style="height: 100%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 65%;position: relative">
                        <InspectionCenter ref="InspectionCenterRef"/>
                    </a-col>
                    <a-col :span="24" style="height: 35%;position: relative">
                        <a-col :span="12" style="height: 100%;padding: 0 10px;">
                          <InspectionPeriod ref="InspectionPeriodRef"/>
                        </a-col>
                        <a-col :span="12" style="height: 100%;padding: 0 10px;">
                          <InspectionMaintenanceCompleted ref="InspectionMaintenanceCompletedRef" :titleImage="titleImage"/>
                        </a-col>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="6" class="cell-right">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 100%">
                      <InspectionAbnormalCondition ref="InspectionAbnormalConditionRef"/>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import InspectionAndMaintenance from './modules/InspectionAndMaintenance'
import InspectionTaskMonth from './modules/InspectionTaskMonth'
import InspectionDynamics from './modules/InspectionDynamics'
// import echartMap from './modules/echartMap'
import InspectionCenter from './modules/InspectionCenter'
import InspectionRegionalRanking from './modules/InspectionRegionalRanking'
import InspectionCompletedMonth from './modules/InspectionCompletedMonth'
import InspectionMaintenanceCompleted from './modules/InspectionMaintenanceCompleted'
import MaintenancePeriod from './modules/MaintenancePeriod'
import InspectionPeriod from './modules/InspectionPeriod'
import InspectionAbnormalCondition from './modules/InspectionAbnormalCondition'
export default {
    components: {
        InspectionAndMaintenance,
        InspectionTaskMonth,
        InspectionDynamics,
        InspectionCenter,
        InspectionRegionalRanking,
        InspectionCompletedMonth,
        InspectionMaintenanceCompleted,
        MaintenancePeriod,
        InspectionPeriod,
        InspectionAbnormalCondition
    },
    data() {
        return {
            titleImage:require("@/assets/images/title-gradual.png"),
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.init()
        })
    },
    methods: {
        init() {
            this.$refs.InspectionAndMaintenanceRef.init()
            // this.$refs.InspectionTaskMonthRef.init()
            // this.$refs.InspectionDynamicsRef.init()
            this.$refs.InspectionCenterRef.init()
            this.$refs.InspectionRegionalRankingRef.init()
            // this.$refs.InspectionCompletedMonthRef.init()
            this.$refs.InspectionMaintenanceCompletedRef.init()
            this.$refs.MaintenancePeriodRef.init()
            this.$refs.InspectionPeriodRef.init()
            this.$refs.InspectionAbnormalConditionRef.init()
        }
    }
}
</script>
<style lang="less" scoped>
.index-main{
    height: 100%;
    padding: 12px;
}
.cell-left,.cell-right{
    height: 100%;
    padding-left: 12px;
    padding-right: 12px;
    //position: absolute;
}
.cell-bottom{
    height: 30%;
    //position: absolute;
    background: url('~@/assets/images/cell-bottom.png') no-repeat;
    background-size: 100% 100%;
}
.cell-left{
    top: 0;
    left: 0;
}
.cell-right{
    top: 0;
    right: 0;
}
.cell-bottom{
    bottom: 0;
    height: 30%;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #B6DEFF;
        height: 100%;
    }
    /deep/ .m-panel-bar{
        height: 40px;
    }
    /deep/ .m-panel-bar-title{
        font-size: 18px;
        font-weight: 700;
        color: #B6DEFF;
        display: flex;
        align-items: center;
        padding-left: 7px;
        border-bottom: 5px solid transparent; /* 创建透明的下边框 */
        border-image: url('~@/assets/images/title-gradual.png') 5 stretch; /* 指定图像路径、重复次数和对齐方式 */
        border-image-repeat: stretch;
    }
    /deep/ .m-panel-body{
        height: calc(100% - 40px)
    }
    /deep/ .total-sum{
        color: #A8C6F3;
        font-weight: bold;
        font-size: 33px;
        margin-top: 33px;
    }
    /deep/ .unit{
        font-size: 12px;
        color: #A8C6F3;
        margin-left: 5px;
    }
    /deep/ .m-total{
        padding: 10px;
        line-height: 1;
        
        .total-title{
            color: #01B8FD;
            font-weight: 500;
            font-size: 16px;
        }
        .total-type-title{
            color: #B6DEFF;
        }
    }
    /deep/ .font-24{
        font-size: 24px;
    }
    /deep/ .flex-center{
        display: flex;
        align-items: center;
    }
}
.cell-left{
    position: relative;
    background: url('~@/assets/images/cell-left.png') no-repeat;
    background-size: 100% 100%;
}
.cell-right{
    position: relative;
    background: url('~@/assets/images/cell-right.png') no-repeat;
    background-size: 100% 100%;
}
</style>